<template>
  <v-container fluid="" class="ma-0 pa-0">
    <v-card width="100%" flat="" outlined="">
      <v-card-title>
        <b>Payment Information</b>
      </v-card-title>
      <v-alert type="error" v-if="error" dense="" text="" class="ml-4 mr-4">
        Could not load billing information. Please contact support@arist.co
      </v-alert>

      <div class="pl-4 pr-4">
        <!-- <p class="body-1">
          <span><b>Billing Email:</b></span> Same as super admin account
          (joe@arist.co)
        </p> -->
        <p class="body-1 d-flex">
          <span class="mr-2"><b>Credit Card:</b></span>
          <v-skeleton-loader
            v-if="loading"
            type="text"
            width="100%"
            max-width="250px"
          ></v-skeleton-loader>
          <img
            v-if="defaultcard"
            max-height="15px"
            style="object-fit:contain"
            width="40px"
            contain=""
            :src="getSource(defaultcard.brand)"
            class="mr-2"
          />
          <span v-if="defaultcard">
            **** **** ****
            {{ defaultcard.last4 }}
            {{ String(defaultcard.brand).toUpperCase() }}</span
          >
          <v-btn
            v-if="!loading"
            class="mt-a mb-a ml-3"
            rounded=""
            depressed=""
            dark=""
            @click="showCard = true"
            color="green"
            x-small=""
            >{{ defaultcard ? "Update" : "Add Card" }}</v-btn
          >
        </p>
      </div>
      <!-- <v-list-item>
        <v-list-item-action>
          <div class="d-flex">
            <v-btn icon="" small="">
              <v-icon small="">mdi-delete</v-icon>
            </v-btn>
          </div>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title
            >VISA **** **** **** 4242
            <v-chip small="" dark color="blue"
              >Default</v-chip
            ></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item> -->
    </v-card>
    <updatecard
      v-model="showCard"
      @success="
        showCard = false;
        getCreditCard();
      "
    />
  </v-container>
</template>

<script>
import services from "@/services";
import updatecard from "../update-credit-card";
export default {
  components: {
    updatecard
  },
  data: () => ({
    error: false,
    showCard: false,
    cards: [],
    defaultid: "",
    loading: true
  }),
  computed: {
    defaultcard() {
      if (this.default === "") {
        return null;
      }
      const dcards = this.cards.filter(card => {
        console.log(card, this.defaultid);
        return card.id === this.defaultid;
      });
      return dcards.pop() || null;
    },
    imagecards() {
      return {
        visa: require("@/assets/imgs/paymenticons/visa.png"),
        discover: require("@/assets/imgs/paymenticons/discover.png"),
        mastercard: require("@/assets/imgs/paymenticons/mastercard.png"),
        american: require("@/assets/imgs/paymenticons/american.png")
      };
    }
  },
  methods: {
    getSource(brand) {
      switch (`${brand}`.toLowerCase()) {
        case "amex":
          return this.imagecards.american;
        case "visa":
          return this.imagecards.visa;
        case "discover":
          return this.imagecards.discover;
        case "mastercard":
          return this.imagecards.mastercard;
      }
    },
    async getCreditCard() {
      try {
        this.loading = true;
        this.cards = [];
        this.defaultid = "";
        const x = await services.billing.paymentMethods.get();
        console.log("Found payment details");
        this.cards = x.paymentMethods.cards;
        this.defaultid = x.paymentMethods.defaultcard;
        this.loading = false;
      } catch (err) {
        this.error = true;
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getCreditCard();
  }
};
</script>

<style></style>
